import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
function StarRating(_ref) {
  var id = _ref.id,
    name = _ref.name,
    edit = _ref.edit,
    rating = _ref.rating,
    handleUserInput = _ref.handleUserInput;
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: "star-rating__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-text-1 demibold star-rating-category"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "seller-rating__stars"
  }, /*#__PURE__*/React.createElement(StarRatings, {
    rating: rating ? rating.score || 0 : 0,
    isSelectable: edit,
    starRatedColor: "#EDA318",
    starHoverColor: "#EDA318",
    starDimension: "28px",
    starSpacing: "4px",
    changeRating: function changeRating(e) {
      if (edit) handleUserInput('ratings', e, id);
    },
    numberOfStars: 5,
    name: "rating"
  })));
}
StarRating.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  edit: PropTypes.bool.isRequired,
  rating: PropTypes.shape({}).isRequired,
  handleUserInput: PropTypes.func.isRequired
};
export default StarRating;